export interface IntermediateResult {
	timestamp: number;
	videoKbps: number;
}

export interface QualityResults {
	bitrate: number;
	packetLossRatio: number;
}

export function passesQualityCheck(qualityResults: QualityResults) {
    return qualityResults.bitrate >= 300000 && qualityResults.packetLossRatio <= 0.05;
}
